import Marionette from "backbone.marionette";

import MastersModel from "models/mastersModel.js";
import MasterDetailView from "views/masters/mastersViewDetail.js";
import FiltersModel from "models/filtersModel.js";

import MastersTpl from "views/masters/mastersView.ejs";
import LineTpl from "views/masters/formLine.ejs";
import CSS from "views/masters/masters.css";

import PaginationView from "views/pagination/pagination.js";

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.LayoutView.extend({
    initialize: function(data) {
        $('.content-wrapper').css({ 'margin-left': '230px' });

        this.tableName = data.table;
        this.model = new MastersModel();
        this.listenTo(S.mApp, "update:masters", function(ev) {
            this.collection.fetch({
                data: {
                    tableacces: this.tableName + "_" + S.instanceId,
                    instanceId: S.instanceId,
                    page: 1
                },
                beforeSend: T.useToken,
            });
        });
        this.listenTo(this.collection, "sync", this.applyView.bind(this));
        this.listenTo(S.mApp, "next", this.next.bind(this));
        this.listenTo(S.mApp, "prev", this.prev.bind(this));
        this.listenTo(S.mApp, "page", this.page.bind(this));
        var filtersModel = new FiltersModel();
        filtersModel.fetch({
            data: {
                page: "masters_" + this.tableName + "_" + S.instanceId,
            },
            beforeSend: T.useToken,
            success: function() {
                // Pre filters
                this.filters = filtersModel.toJSON();
            }.bind(this)
        });
    },
    filter: 0,
    template: MastersTpl,
    render: function() {

        $("#loaderContainer").show();

        ////hacer un reset de la collection siempre ..
        this.collection.reset();
        this.collection.fetch({
            data: {
                tableacces: this.tableName + "_" + S.instanceId,
                instanceId: S.instanceId,
                page: 1
            },
            beforeSend: T.useToken,
            success: function() {

                this.allaccounts = this.collection.allaccounts;


                $("#loaderContainer").hide();
                this.$el.html(this.template({
                    table: S.userInfo.attributes.lang[this.tableName.toUpperCase()],
                    desc: this.collection.desc,
                    lang: this.collection.lang,
                    accounts: this.collection.accounts,
                    allaccounts: this.collection.allaccounts,
                    rolee: S.userInfo.get("role")
                }));

            }.bind(this)
        });



    },
    applyView: function() {

        if (_.isEmpty(this.filters)) {
            $("#lines").html(""); // Empty filters container                      
            $("#lines").append(LineTpl({
                filters: "",
                desc: this.collection.desc,
                lang: this.collection.lang,
                showremove: false
            }));
        } else {
            $("#lines").html(""); // Empty filters container
            var showit = false;
            for (var f in this.filters) {
                $("#lines").append(LineTpl({
                    filters: this.filters[f],
                    desc: this.collection.desc,
                    lang: this.collection.lang,
                    showremove: showit
                }));
                showit = true;
            }
        }

        var buttonAvailable = '<span class="ion ion-ios-compose text-light-blue" id="edit"></span>&nbsp;';

        var columns = [];

        var integerFields = [
            "mejoras_importe", "mejoras_vida", "mejoras_amortizacion", "mejoras_vnc", "mejoras_amorAcum",
            "catastrales_anno",
            "titulo_valor"
        ];
        var decimalFields = [
            "catastrales_val_suelo", "catastrales_val_cons", "catastrales_valor", "mejoras_importe", "catastrales_sup_suelo", "catastrales_sup_cons",
        ];


        for (var d in this.collection.desc) {

            var className = "";
            var attr = this.collection.desc[d];


            ///Quitar del if 
            /**
             * catastrales_naturaleza / registrales_registro / acuerdos_organo
             */
            if (attr.Field === "is_mejorarazonable" || attr.Field === "registrales_obs" || attr.Field === "acuerdos_organo" || attr.Field === "catastrales_obs" || attr.Field === "registrales_cargas" || attr.Field === "registrales_registro" || attr.Field === "catastrales_naturaleza" || attr.Field === "instanceId" || attr.Field === "mejoras_area" || attr.Field === "numeroCuenta" || attr.Field === "mejoras_amorAcum")
                continue;


            if (integerFields.indexOf(attr.Field) >= 0) { className = "integer text-right"; }

            if (decimalFields.indexOf(attr.Field) >= 0)
                className = " decimal text-right ";

            if (attr.Field == 'mejoras_amortizacion' || attr.Field == 'mejoras_vnc' || attr.Field == 'mejoras_amorAcum') {
                className = " text-right  money ";
            }


            ////////    sortable: true,
            var column = {
                field: attr.Field,
                title: this.collection.lang[attr.Field.toUpperCase()],

                class: className
            };
            columns.push(column);
        }

        columns.push({
            field: "button",
            title: ""
        });

        $("#mainData").bootstrapTable({
            striped: true,
            uniqueId: 'id',
            sidePagination: 'server',
            columns: columns
        });


        var data = [];
        _.each(this.collection.models, function(model) {

            var attr = model.attributes;
            var mejorasCuentaLife = 0;

            if (this.tableName === 'mejoras') {

                if (typeof attr.mejoras_cuenta === 'undefined') {} else {
                    mejorasCuentaLife = this.allaccounts[attr.mejoras_cuenta]['_life'];
                }

                var mejorasVidaNorma = attr.mejoras_vida;

                if (attr.mejoras_vida <= 0) {
                    mejorasVidaNorma = mejorasCuentaLife;
                }

                ///// LA AMORTIZACION  
                var amortiValu = this.allaccounts[attr.mejoras_cuenta]['_amortiz'];
                var mejorAmortiza = attr.mejoras_amortizacion;

                if (parseFloat(attr.mejoras_amortizacion) <= 0) {
                    mejorAmortiza = amortiValu;
                }


                var cuentaEncurso = this.allaccounts[attr.mejoras_cuenta]['_encurs'];
                var textCuenta = this.collection.lang[attr.mejoras_cuenta];

                if (attr.mejoras_cuenta) {
                    attr.mejoras_cuenta = attr.numeroCuenta + " - " + textCuenta;
                    if (attr.mejoras_enCurso == 1) {
                        attr.mejoras_cuenta = cuentaEncurso + " - " + textCuenta;
                        mejorAmortiza = 0;
                        mejorasVidaNorma = 0;
                    }
                }

                /* if (attr.mejoras_area)
                    attr.mejoras_area = this.collection.lang[attr.mejoras_area]; */
                if (attr.mejoras_area) delete attr.mejoras_area;
                if (attr.numeroCuenta) delete attr.numeroCuenta;
                if (attr.mejoras_amorAcum) delete attr.mejoras_amorAcum;
                var lang = this.collection.lang;
                var areaFuncional;

                if (attr.mejoras_enCurso == 1) {
                    attr.mejoras_enCurso = this.collection.lang["YES"];
                } else {
                    attr.mejoras_enCurso = this.collection.lang["NO"];
                }


                attr.mejoras_vida = mejorasVidaNorma;

                attr.mejoras_amortizacion = mejorAmortiza;

            }


            if (model.get("value") && S.userInfo.get("role") === "3") {

                if (S.userInfo.get("role") != "3") {

                    switch (model.get("value")) {
                        case "3":
                        case "2":
                            buttonAvailable = '<span class="ion ion-ios-compose text-light-blue" id="edit"></span>&nbsp;';
                            break;
                    }

                } else {
                    buttonAvailable = '';
                }



            }

            attr.button = '<div class="btn-group unbreakable" role="group">' + buttonAvailable + '</div>';
            data.push(attr);
        }.bind(this));


        $("#mainData").bootstrapTable("removeAll");
        $("#mainData").bootstrapTable("append", data);

        this.pagination.show(new PaginationView({
            attributes: this.collection.pageAttributes
        }));

        $("#wrapper").height(window.innerHeight);

        $(".dateGroup").datetimepicker({
            format: 'DD/MM/YYYY'
        });

        $('.money:not(th)').mask("#.##0,00", { reverse: true });
        $('.decimal:not(th)').mask("#.##0,00", { reverse: true });
        $('.integer:not(th)').mask("#.##0", { reverse: true });
        $('.number:not(th)').mask("##0", { reverse: true });

        // Remove active menu items
        $(".sidebar li").removeClass("active");
        $(".sidebar li > ul").removeClass("active menu-open");
        // Add active menu items
        if (this.tableName == "mejoras") {
            $("#LISTS").parent().addClass("active");
            $("#LISTS").parent().find("ul").addClass("in");
            $("[id^=MEJORAS_]").parent().addClass("active");

        } else {
            var currentTable = this.tableName.toUpperCase();
            $("#MASTERS").parent().addClass("active");
            $("#MASTERS").parent().find("ul").addClass("in");
            $("#" + currentTable).parent().addClass("active");
        }

        // Don't apply on firstload
        // this.adjustForm();
    },
    events: {
        "click .searchButton.add": "addLine",
        "click .searchButton.remove": "removeLine",
        "keyup input": "searchByVal",
        /////  "sort.bs.table #mainData": "orderData",
        "change #fieldname": "adjustForm",
        "submit #searchForm": "submit",
        "click #removeFilter": "removeFilter",
        "click #edit": "editValue",
        "click #nuevo": "insertValue"
    },
    params: {},
    orderData: function(ev, $param1, $param2) {
        this.filter = 0;
        ev.preventDefault();
        var page = parseInt($(".pagination li.active").attr("id").split("-")[1]);
        this.params = {
            column: $param1,
            order: $param2
        };
        this.searchService(page, this.params, false);
    },
    searchService: function(page, params, resetFilters) {
        $("#loaderContainer").show();



        //FIXME: Arreglo rápido, no repetir código de submit cuando hay filtro
        if (!this.filter) {
            var data = {};
            var searchItems = $(".search");

            $.each(searchItems, function() {
                if ($(this).val())
                    data[$(this).attr("name")] = $(this).val();
            });

            data.page = page || 1;
            data.instanceId = S.instanceId;
            data.tableacces = this.tableName + "_" + S.instanceId;
            data.resetFilters = resetFilters;

            if (params && params.column) {
                data.column = params.column;
                data.order = params.order;
            }

            this.collection.fetch({
                data: data,
                beforeSend: T.useToken,
                instanceId: S.instanceId
            }).always(function() {
                $("#loaderContainer").hide();
            });
        } else {
            var request = {};
            var data = [];
            var newFilters = [];
            $.each($(".formLine"), function() {
                var line = {};
                line.fieldname = $(this).find("#fieldname").val();
                line.nbcomparador = $(this).find(".operator:visible").val();
                line.value = $(this).find(".value:visible").val();
                line.operator = $(this).find("#operator").val();
                line.operator === "--" ? "" : line.operator;
                line.nbfield = $(this).find(".operator:visible").attr("id");
                line.valuefield = $(this).find(".value:visible").attr("id");
                if (line.fieldname) {
                    data.push(line);
                    newFilters.push(line);
                }
            });

            this.filters = newFilters;
            request.instanceId = S.instanceId;
            request.data = data;
            request.page = page || 1;
            request.tableacces = this.tableName + "_" + S.instanceId;
            request.resetFilters = resetFilters;

            this.model.save(request, {
                beforeSend: T.useToken,
                success: function() {

                    this.collection.set(this.model.attributes._embedded);
                    //Update page attributes as well
                    this.collection.pageAttributes = {
                        page: this.model.attributes.page,
                        page_count: this.model.attributes.page_count,
                        page_size: this.model.attributes.page_size,
                        total_items: this.model.attributes.total_items
                    };
                    this.applyView();
                    $("#loaderContainer").hide();
                }.bind(this)
            });
        }
    },
    submit: function(ev) {

        this.filter = 1;
        ev.preventDefault();
        var request = {};
        var data = [];
        var newFilters = [];
        $.each($(".formLine"), function() {
            var line = {};
            line.fieldname = $(this).find("#fieldname").val();
            line.nbcomparador = $(this).find(".operator:visible").val();
            line.value = $(this).find(".value:visible").val();
            line.operator = $(this).find("#operator").val();
            line.operator === "--" ? "" : line.operator;
            line.nbfield = $(this).find(".operator:visible").attr("id");
            line.valuefield = $(this).find(".value:visible").attr("id");
            if (line.fieldname) {
                data.push(line);
                newFilters.push(line);
            }
        });

        this.filters = newFilters;
        request.instanceId = S.instanceId;
        request.tableacces = this.tableName + "_" + S.instanceId;
        request.data = data;
        request.page = 1;

        this.model.save(request, {
            beforeSend: T.useToken,
            success: function() {
                this.collection.set(this.model.attributes._embedded);
                //Update page attributes as well
                this.collection.pageAttributes = {
                    page: this.model.attributes.page,
                    page_count: this.model.attributes.page_count,
                    page_size: this.model.attributes.page_size,
                    total_items: this.model.attributes.total_items
                };
                this.applyView();
                // $("#removeFilter").prop("disabled", false);
            }.bind(this)
        });
    },
    addLine: function(ev) {
        var operator = $(ev.target).parents(".formLine").find("#operator");

        if (operator.val() === "--")
            operator.val("and");

        $("#lines").append(LineTpl({
            filters: "",
            desc: this.collection.desc,
            lang: this.collection.lang,
            showremove: true
        }));

        //Date controls
        $(".dateGroup").datetimepicker({
            format: 'DD/MM/YYYY'
        });

        this.adjustForm();
    },
    removeLine: function(ev) {
        $(ev.target).parents(".formLine").remove();
    },
    adjustForm: function() {


        var desc = this.collection.desc;
        $(".formLine").each(function() {
            var selector = $(this).find("#fieldname");
            var field = {};
            for (var d in desc) {
                if (desc[d].Field === selector.val()) {
                    field = desc[d];
                    field.Type = desc[d].Type.substring(0, 3);
                }
            }
            $(this).find("#operatorHolder select").addClass("hidden");
            $(this).find("#valueHolder > *").addClass("hidden");

            switch (field.Type) {
                case "dat":
                    $(this).find("#nbcomparador").removeClass("hidden");
                    $(this).find("#dtpickerBuscar").removeClass("hidden");
                    break;
                    //Number
                case "dec":
                case "flo":
                case "int":
                    $(this).find("#nbcomparador").removeClass("hidden");
                    $(this).find("#numberValue").removeClass("hidden");
                    break;
                    //String
                case "var":
                case "tex":
                    $(this).find("#nbIncluye").removeClass("hidden");
                    $(this).find("#textValue").removeClass("hidden");
                    break;
                default:
                    $(this).find("#nbIgual").removeClass("hidden");
                    $(this).find("#textValue").removeClass("hidden");
            }
        });
    },
    editValue: function(ev) {
        var master_id = $(ev.target).parents("tr").attr("data-uniqueid");
        S.mApp.trigger("modal", {
            view: new MasterDetailView({
                model: this.collection.get(master_id),
                id: master_id,
                desc: this.collection.desc,
                lang: this.collection.lang,
                accounts: this.collection.accounts,
                allaccounts: this.collection.allaccounts,
                tablename: this.tableName
            })
        });

        // this.applyView();
    },
    insertValue: function(ev) {
        S.mApp.trigger("modal", {
            view: new MasterDetailView({
                desc: this.collection.desc,
                lang: this.collection.lang,
                accounts: this.collection.accounts,
                allaccounts: this.collection.allaccounts,
                tablename: this.tableName
            })
        });

        // Needed for modal's inputs
        $(".dateGroup").datetimepicker({
            format: 'DD/MM/YYYY'
        });

        $('.money:not(th)').mask("#.##0,00", { reverse: true });
        $('.decimal:not(th)').mask("#.##0,00", { reverse: true });
        $('.integer:not(th)').mask("#.##0", { reverse: true });
        $('.justnumber:not(th)').mask("#0", { reverse: true });
        $('.number:not(th)').mask("###0", { reverse: true });

    },
    capitalize: function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    removeFilter: function() {
        this.filter = 0;
        // Reset filters
        this.filters = "";
        $("#lines").html(""); // Empty filters container              
        this.searchService(1, this.params, true);
    },
    next: function(ev) {
        var nextPage = parseInt($(".pagination li.active").attr("id").split("-")[1]) + 1;
        this.searchService(nextPage, this.params, false);
    },
    prev: function(ev) {
        var prevPage = parseInt($(".pagination li.active").attr("id").split("-")[1]) - 1;
        this.searchService(prevPage, this.params, false);
    },
    page: function(ev) {
        var page = parseInt($(ev.target).parent().attr("id").split("-")[1]);
        this.searchService(page, this.params, false);
    },
    formatNumber: function(n, symbol) {
        var format = require('format-number');
        var myFormat = format({ prefix: '', suffix: ' ' + symbol, integerSeparator: '.', decimal: ',' });
        var formattedNumber = myFormat(n, { noSeparator: false });
        return formattedNumber;
    },
    regions: {
        pagination: "#paginationHolder"
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/masters/mastersView.js
// module id = 194
// module chunks = 0